import React from 'react';
import { NavigationContainer } from '@react-navigation/native';
import { AppRoutes } from "navigations/app-routes";
import { createNativeStackNavigator } from "@react-navigation/native-stack";
import _ from "lodash";
import { stackProps, stackScreenProps } from "utils/helper-navigation";
import HelperString from "utils/helper-string";
import { navigationContainerProps } from 'utils/helper-navigation-container'
import NotificationsScene from 'scenes/notifications'
import { createPageTitle } from 'utils/helper-page-title';

const Stack = createNativeStackNavigator();

const screens = {
	[AppRoutes.NOTIFICATIONS]: {
		component: NotificationsScene,
	}
}

const NotificationNavigator = ( props ) => {
	return (
		<NavigationContainer
			{ ...navigationContainerProps }>

			<Stack.Navigator
				{ ...stackProps }>

				{ _.map( screens, ( screen, name ) => {
					return (
						<Stack.Screen
							key={ HelperString.hash( `AuthenticationNavigator`, name ) }
							{ ...stackScreenProps }
							name={ name }
							options={{
								title: createPageTitle( _.get( screen, 'title', null ) )
							}}
							component={ screen.component }
						/>
					);
				})}
			</Stack.Navigator>
		</NavigationContainer>
	);
};

export default NotificationNavigator
